










































import Vue from 'vue'

import { priceFormatter } from '@/common/utils'
import { ProductDetail } from '@/stockLibrary/queries/types'
import ModalCategoryList from '@/stockLibrary/components/ModalCategoryList.vue'

import { FullColorCategory } from '@/stockLibrary/queries/types'


export default Vue.extend({
  components: { ModalCategoryList },
  props: {
    productDetail: {
      type: Object as () => ProductDetail,
      required: true
    },
    selectedCategoryId: {
      type: String,
      required: true
    },
    categories: {
      type: Array as () => FullColorCategory[],
      required: true
    },
    selectedCategoryName: {
      type: String,
      required: true
    }
  },
  data(): {
    showCategoryModal: boolean
  } {
    return {
      showCategoryModal: false
    }
  },
  methods: {
    priceFormatter,
    onChangeCategory(id: string) {
      this.showCategoryModal = false
      if (this.selectedCategoryId === id) return
      this.$emit('onChangeCategory', id)
    }
  }
})
